import { motion } from "framer-motion";
import { Sparkles, ArrowRight } from "lucide-react";
import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";

const PromoSlot = () => {
  const { data } = useQuery({
    queryKey: ["activePromo"],
    queryFn: api.cms.activePromo,
    staleTime: 5 * 60 * 1000,
  });

  const promo = data?.promo;
  if (!promo) return null;

  return (
    <section className="py-10 md:py-14">
      <div className="container-max px-5">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="relative rounded-2xl overflow-hidden"
          style={{ background: "var(--hero-gradient)" }}
        >
          {/* Pattern overlay */}
          <div
            className="absolute inset-0 opacity-[0.04]"
            style={{
              backgroundImage:
                "radial-gradient(circle at 1px 1px, white 1px, transparent 0)",
              backgroundSize: "24px 24px",
            }}
          />

          <div className="relative z-10 px-8 py-10 md:px-12 md:py-14 flex flex-col md:flex-row items-center gap-6 md:gap-10">
            <div className="w-14 h-14 rounded-2xl bg-secondary/20 flex items-center justify-center flex-shrink-0">
              <Sparkles size={24} className="text-secondary" />
            </div>
            <div className="flex-1 text-center md:text-left">
              <h3 className="text-xl md:text-2xl font-bold text-primary-foreground mb-1">
                {promo.title}
              </h3>
              {promo.subtitle && (
                <p className="text-sm text-primary-foreground/60">{promo.subtitle}</p>
              )}
            </div>
            {promo.cta_text && (
              <a
                href={promo.cta_link ?? "#catalog"}
                className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-secondary text-secondary-foreground font-semibold text-sm hover:bg-gold-light transition-colors shine whitespace-nowrap"
              >
                {promo.cta_text}
                <ArrowRight size={16} />
              </a>
            )}
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default PromoSlot;
